import React, { useState } from "react";
import Papa from "papaparse";

function CSVUploader() {
  const [data, setData] = useState([]);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];

    // Check if a file is selected
    if (file) {
      Papa.parse(file, {
        header: true,
        complete: function (results) {
          setData(results.data);
        },
        error: function (error) {
          console.error("Error while parsing:", error.message);
        },
      });
    }
  };

  // -------- Data for the import in the table ---------

  let schools = {};
  let students = [];

  const parseCSVData = (data) => {
    data.forEach((row) => {
      let tmpSchool = null;
      let tmpSchoolCode = row.Scuola;
      schools.forEach((s) => {
        if (!s.Scuola === tmpSchoolCode) {
          tmpSchool = {
            Scuola: tmpSchoolCode,
            Sede: row.Sede,
            Classes: [
              {
                "Anno di Corso": row["Anno di Corso"],
                Sezione: row.Sezione,
                "Cod.Quadro Orario": row["Cod.Quadro Orario"],
                "Quadro Orario": row["Quadro Orario"],
              },
            ],
          };

          schools.push(tmpSchool);
        } else {
          s.Sede = row.Sede;

          if (s.Classes.length === 0) {
            s.Classes.push({
              "Anno di Corso": row["Anno di Corso"],
              Sezione: row.Sezione,
              "Cod.Quadro Orario": row["Cod.Quadro Orario"],
              "Quadro Orario": row["Quadro Orario"],
            });
          } else {
            s.Classes.forEach((c) => {
              if (
                c["Anno di Corso"] === row["Anno di Corso"] &&
                c.Sezione === row.Sezione
              ) {
                c["Cod.Quadro Orario"] = row["Cod.Quadro Orario"];
                c["Quadro Orario"] = row["Quadro Orario"];
              } else {
                s.Classes.push({
                  "Anno di Corso": row["Anno di Corso"],
                  Sezione: row.Sezione,
                  "Cod.Quadro Orario": row["Cod.Quadro Orario"],
                  "Quadro Orario": row["Quadro Orario"],
                });
              }
            });
          }
        }
      });

      if (tmpSchool) {
        let tmpClasses = [];
        if (tmpSchool.Classes.length === 0) {
          tmpSchool.Classes.push({});
        }
      }
    });
  };

  return (
    <div>
      <h2>Upload and Parse CSV</h2>
      <input type="file" accept=".csv" onChange={handleFileUpload} />
      <div>
        {data.length > 0 && (
          <table>
            <thead>
              <tr>
                {Object.keys(data[0]).map((key) => (
                  <th key={key}>{key}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr key={index}>
                  {Object.keys(row).map((key) => (
                    <td key={key}>{row[key]}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default CSVUploader;
